
import React, { Component } from 'react';

export default class Timer extends Component {
    state = {
        minutes: 10,
        seconds: 0,
    }

    diference(exAt)
    {
        let unix = new Date(exAt).getTime() - new Date().getTime();

        this.setState({
            minutes: Math.floor((unix / 1000 / 60) % 60),
            seconds: Math.floor((unix / 1000) % 60)
        });

    }

    componentDidMount() {
        const { expiredAt } = this.props;
        this.diference(expiredAt.date);
        this.myInterval = setInterval(() => {
            const {minutes, seconds} = this.state;
            if (seconds > 0) {
                this.setState(({ seconds }) => ({
                    seconds: seconds - 1
                }));
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(this.myInterval)
                } else {
                    this.setState(({ minutes }) => ({
                        minutes: minutes - 1,
                        seconds: 59
                    }));
                }
            }

        }, 1000);
    }


    componentWillUnmount() {
        clearInterval(this.myInterval);
    }

    render() {
        const { minutes, seconds } = this.state;
        return (
            <div className="checkout-data__qr">
                { minutes === 0 && seconds === 0
                    ? <span><h2>QR expirado</h2>Solicite un nuevo QR al comercio</span>
                    : <span>{minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds} min <br />
                    Restantes para usar este QR.</span>
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./client/components/Clock.js